package com.devi3east.bashbuddy.common.service

actual fun appVersionProvider(): AppVersionProvider {

    return WebAppVersionProvider()
}

class WebAppVersionProvider : AppVersionProvider {

    override val buildNumber: Int
        get() = Int.MAX_VALUE

    override val versionName: String
        get() = "web"

    override val platform: Platform
        get() = Platform.WEB
}